import { getRuntimeConfig } from '../app/shared/config/runtime-config';

const pick = (value: string | undefined, fallback: string) =>
  value && value.trim().length > 0 ? value : fallback;

export const environment = {
  envName: 'local',
  production: false,
  get apiUrl() {
    return pick(getRuntimeConfig().apiUrl, 'http://localhost:3007/api');
  },
  get clientAppUrl() {
    return pick(getRuntimeConfig().clientAppUrl, 'http://localhost:6200');
  },
  firebaseConfig: {
    projectId: 'cursive-48881',
    appId: '1:59599162097:web:bcddec0003d56884d4b750',
    databaseURL: 'https://cursive-48881-default-rtdb.firebaseio.com',
    storageBucket: 'cursive-48881.appspot.com',
    apiKey: 'AIzaSyDllJKo-Znn7BlyrO92DOWH78pX3inP6SU',
    authDomain: 'auth-cursive-development.foragerone.com',
    messagingSenderId: '59599162097',
  },
};
